import React, { Component } from 'react';

export default class PencilIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M53.245,0l-46.04,46.04l-7.205,33.96l33.953,-7.205l46.047,-46.047l-26.755,-26.748Zm0,8.179l8.208,8.208l-38.911,38.906l-8.206,-8.206l38.909,-38.908Zm-36.05,62.192l-7.569,-7.568l2.906,-13.199l17.859,17.862l-13.196,2.905Zm15.713,-4.712l-8.203,-8.203l38.906,-38.911l8.208,8.203l-38.911,38.911Z"/>
              </g>
            </svg>
        )
    }
}
